module.exports = __webpack_public_path__ + "img/makerdai.4cda8f7e.svg";